import { Order } from '../../helpers/Order';
import { IOrderClause } from '../../ServerApi/types/IOrderClause';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const siteUserContentDefaultSortOrder: IOrderClause[] = [Order.asc(OrderKeys.name)];

export const siteUserContentSortOptions: OptionsDictionary = {
  // Mixed Content does not support relevance and owner sort does not make sense on the user space
  'name': SortOptions.name,
  'type': SortOptions.type,
  'updated': SortOptions.updated
};
